import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import DataTable from "../../components/DataTable";
import Alert from "../../components/Alert";
import { createLookupApi } from "../../api/lookupApi";
import { listExamGrades, createExamGrade, deleteExamGrade } from "../../api/examApi";
import "../Users/UsersPage.css";
import "../Attendance/Attendance.css";

const classApi = createLookupApi("classes");
const emptyForm = { gradeName: "", gradePoint: 5, numberLow: 80, numberHigh: 100, pointLow: 4.5, pointHigh: 5, gradeComments: "" };

/** Grade bands per class — used both by percentage (per-subject) and by GPA point (overall result letter grade). */
export default function ExamGradePage() {
  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState("");
  const [grades, setGrades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    classApi.list().then((list) => {
      setClasses(list);
      if (list.length > 0) setClassId(String(list[0].id));
    });
  }, []);

  const load = () => {
    if (!classId) return;
    setLoading(true);
    listExamGrades(classId)
      .then(setGrades)
      .catch(() => setError("Failed to load grades."))
      .finally(() => setLoading(false));
  };

  useEffect(load, [classId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await createExamGrade({
        classId: Number(classId),
        gradeName: form.gradeName,
        gradePoint: Number(form.gradePoint),
        numberLow: Number(form.numberLow),
        numberHigh: Number(form.numberHigh),
        pointLow: Number(form.pointLow),
        pointHigh: Number(form.pointHigh),
        gradeComments: form.gradeComments,
      });
      setSuccess("Grade created.");
      setForm(emptyForm);
      load();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to create.");
    }
  };

  const handleDelete = async (row) => {
    if (!window.confirm(`Delete grade "${row.gradeName}"?`)) return;
    setError("");
    try {
      await deleteExamGrade(row.id);
      setSuccess("Deleted.");
      setGrades((prev) => prev.filter((g) => g.id !== row.id));
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to delete.");
    }
  };

  const columns = [
    { key: "gradeName", label: "Grade" },
    { key: "gradePoint", label: "Point" },
    { key: "numberLow", label: "% From" },
    { key: "numberHigh", label: "% To" },
    { key: "pointLow", label: "GPA From" },
    { key: "pointHigh", label: "GPA To" },
  ];

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Grade Configuration</h1>
      </div>

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      <div className="attendance-filters">
        <label>
          Class
          <select value={classId} onChange={(e) => setClassId(e.target.value)}>
            {classes.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
        </label>
      </div>

      <form onSubmit={handleSubmit} className="user-form" style={{ marginTop: 16, marginBottom: 24 }}>
        <label>Grade Name *</label>
        <input value={form.gradeName} onChange={(e) => setForm({ ...form, gradeName: e.target.value })} required placeholder="e.g. A+" />
        <label>Grade Point</label>
        <input type="number" step="0.01" value={form.gradePoint} onChange={(e) => setForm({ ...form, gradePoint: e.target.value })} />
        <label>Percentage From</label>
        <input type="number" value={form.numberLow} onChange={(e) => setForm({ ...form, numberLow: e.target.value })} />
        <label>Percentage To</label>
        <input type="number" value={form.numberHigh} onChange={(e) => setForm({ ...form, numberHigh: e.target.value })} />
        <label>GPA From</label>
        <input type="number" step="0.01" value={form.pointLow} onChange={(e) => setForm({ ...form, pointLow: e.target.value })} />
        <label>GPA To</label>
        <input type="number" step="0.01" value={form.pointHigh} onChange={(e) => setForm({ ...form, pointHigh: e.target.value })} />
        <label>Comments</label>
        <input value={form.gradeComments} onChange={(e) => setForm({ ...form, gradeComments: e.target.value })} />
        <div className="form-actions">
          <button type="submit" className="btn-primary">
            + Add Grade
          </button>
        </div>
      </form>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          rows={grades}
          actions={(row) => (
            <button type="button" className="btn-link danger" onClick={() => handleDelete(row)}>
              Delete
            </button>
          )}
        />
      )}
    </MainLayout>
  );
}
